/* eslint-disable no-console */
import { getRecaptchaConfig } from '../configuration/configuration';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

const recaptchaReadyTimeout = 15000;
const recaptchaLoadPollInterval = 100;

export const getRecaptchaToken = async (action: string = 'username_available'): Promise<string | undefined> => {
  const config = getRecaptchaConfig();
  let pollInterval!: number;

  const recaptchaToken = new Promise<string | undefined>((resolve) => {
    const executeRecaptcha = () => {
      const recaptchaEnterprise = window.grecaptcha?.enterprise;
      if (!recaptchaEnterprise) return false;

      recaptchaEnterprise.ready(() => {
        recaptchaEnterprise
          .execute(config.renderKey, { action })
          .then((token: string) => {
            resolve(token);
            return true;
          })
          .catch(() => {
            resolve(undefined);
            return false;
          });
      });

      return true;
    };

    if (!executeRecaptcha()) {
      pollInterval = window.setInterval(() => {
        if (executeRecaptcha()) window.clearInterval(pollInterval);
      }, recaptchaLoadPollInterval);
    }
  });

  let timeout!: number;
  const recaptchaTimeout = new Promise<undefined>((resolve) => {
    timeout = window.setTimeout(() => resolve(undefined), recaptchaReadyTimeout);
  });

  try {
    return await Promise.race([recaptchaToken, recaptchaTimeout]);
  } finally {
    window.clearInterval(pollInterval);
    window.clearTimeout(timeout);
  }
};
